var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var SlideshowController = /** @class */ (function () {
    function SlideshowController() {
    }
    /*****************************************************************************************************
        * Is using route "api/slideshow/start/{id}/{lng}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} lng
        * @param {BrowserInfo} browser
        * @returns {string}
    ******************************************************************************************************/
    SlideshowController.StartSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("browser", JSON.stringify(data.browser));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/start/{id}/{lng}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/start/{id}/slide/{slideId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} slideId
        * @returns {void}
    ******************************************************************************************************/
    SlideshowController.StartSlide = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/start/{id}/slide/{slideId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/end/{id}/slide/{slideId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} slideId
        * @returns {void}
    ******************************************************************************************************/
    SlideshowController.EndSlide = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/end/{id}/slide/{slideId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/slideshow/start/{id}/{lng}/public" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} lng
        * @param {BrowserInfo} browser
        * @returns {string}
    ******************************************************************************************************/
    SlideshowController.StartSlideShowPublic = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("browser", JSON.stringify(data.browser));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/start/{id}/{lng}/public", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/slideshow/start/{id}/slide/{slideId}/public" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} slideId
        * @returns {void}
    ******************************************************************************************************/
    SlideshowController.StartSlidePublic = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/start/{id}/slide/{slideId}/public", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/slideshow/end/{id}/slide/{slideId}/public" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} slideId
        * @returns {void}
    ******************************************************************************************************/
    SlideshowController.EndSlidePublic = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/end/{id}/slide/{slideId}/public", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow" and http method "POST" to call the back-end.
    Creates a slide show
    
        * @param {SlideShowUploadDto} slideShow  The slide show entity
        * @param {File} media  The media of the slide show post
        * @param {File} masterBackgroundImage  The master background image
        * @returns {SlideShowDownloadDto} The slide show entity how it was created
    ******************************************************************************************************/
    SlideshowController.CreateSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("slideShow", JSON.stringify(data.slideShow));
        if (data.media)
            fd.append("media", data.media);
        if (data.masterBackgroundImage)
            fd.append("masterBackgroundImage", data.masterBackgroundImage);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/{id}" and http method "PATCH" to call the back-end.
    Updates a slide show
    
        * @param {string} id  Id of the slide show
        * @param {SlideShowUploadDto} slideShow  The slide show entity
        * @param {boolean} inheritSlides  Indicates if the slides should be taken from the old slide show
        * @param {File} media  The media of the slide show post
        * @param {File} masterBackgroundImage  The media of the slide's background
        * @returns {SlideShowDownloadDto} The slide show entity how it was created
    ******************************************************************************************************/
    SlideshowController.UpdateSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("slideShow", JSON.stringify(data.slideShow));
        if (data.inheritSlides !== undefined)
            fd.append("inheritSlides", JSON.stringify(data.inheritSlides));
        if (data.media)
            fd.append("media", data.media);
        if (data.masterBackgroundImage)
            fd.append("masterBackgroundImage", data.masterBackgroundImage);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/slideshow/undo/{slideShowId}" and http method "PATCH" to call the back-end.
    Undo the last change for the slide show
    
        * @param {string} slideShowId  Id of the slide show
        * @returns {SlideShowDownloadDto}
    ******************************************************************************************************/
    SlideshowController.UndoSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/undo/{slideShowId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/slideshow/redo/{slideShowId}" and http method "PATCH" to call the back-end.
    Redo the last undid changes for the slide show
    
        * @param {string} slideShowId
        * @returns {SlideShowDownloadDto}
    ******************************************************************************************************/
    SlideshowController.RedoSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/redo/{slideShowId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/{id}" and http method "DELETE" to call the back-end.
    Deletes a slide show
    
        * @param {string} id  The id of the slide show that should be deleted
        * @returns {void}
    ******************************************************************************************************/
    SlideshowController.DeleteSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/{id}" and http method "GET" to call the back-end.
    Returns a slide show
    
        * @param {string} id  The id of the slide show that should be returned
        * @returns {SlideShowDownloadDto} The slide show entity
    ******************************************************************************************************/
    SlideshowController.GetSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/group/{groupId}" and http method "GET" to call the back-end.
    Returns all slide shows of a group
    
        * @param {string} groupId  The group id of the group
        * @returns {SlideShowDownloadDto[]} All slide shows in the group
    ******************************************************************************************************/
    SlideshowController.GetSlideShowsFromGroup = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/group/{groupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/slide/{slideShowId}/{lng}" and http method "POST" to call the back-end.
    Adds a slide
    
        * @param {string} slideShowId  The slide show to add the slide to
        * @param {string} lng  The lng the slide should be added to
        * @param {SlideUploadDto[]} slides  The slide entity
        * @returns {SlideShowDownloadDto} The slide entity how it was added
    ******************************************************************************************************/
    SlideshowController.AddSlidesToSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("slides", JSON.stringify(data.slides));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/slide/{slideShowId}/{lng}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/slide/{slideShowId}/{lng}/pdf" and http method "POST" to call the back-end.
    
        * @param {string} slideShowId
        * @param {string} lng
        * @param {File} pdfFile
        * @returns {SlideShowDownloadDto}
    ******************************************************************************************************/
    SlideshowController.AddPdfSlidesToSlideShow = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.pdfFile)
            fd.append("pdfFile", data.pdfFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/slide/{slideShowId}/{lng}/pdf", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/slide/{id?}" and http method "GET" to call the back-end.
    Gets a slide
    
        * @param {string} id  The id of the slide
        * @returns {SlideDownloadDto} The slide entity
    ******************************************************************************************************/
    SlideshowController.GetSlide = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/slide/{id?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/slide/group/{groupId?}" and http method "GET" to call the back-end.
    Gets all slides of the group and the current user
    
        * @param {string} groupId  The group where the slides should be collected
        * @returns {SlideDownloadDto[]} The slide entity
    ******************************************************************************************************/
    SlideshowController.GetSlides = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/slide/group/{groupId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/slide/{slideId}" and http method "PATCH" to call the back-end.
    Updates a slide
    
        * @param {string} slideId  The id of the slide that should be updated
        * @param {SlideUploadDto} slide  The slide content
        * @param {{[key: string]: File}} slideMedia  Media upload for the slide
        * @param {File} backgroundImage  Media upload for the background of the slide
        * @returns {SlideDownloadDto}
    ******************************************************************************************************/
    SlideshowController.UpdateSlide = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("slide", JSON.stringify(data.slide));
        _.forEach(data.slideMedia, function (val, key) { return fd.append(key, val); });
        if (data.backgroundImage)
            fd.append("backgroundImage", data.backgroundImage);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/slide/{slideId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/slide/undo/{slideId}" and http method "PATCH" to call the back-end.
    Undo last slide changes.
    
        * @param {string} slideId  Id of the slide
        * @returns {SlideDownloadDto}
    ******************************************************************************************************/
    SlideshowController.UndoSlide = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/slide/undo/{slideId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/slide/redo/{slideId}" and http method "PATCH" to call the back-end.
    Redo last undid changes of a slide.
    
        * @param {string} slideId  Id of the slide
        * @returns {SlideDownloadDto}
    ******************************************************************************************************/
    SlideshowController.RedoSlide = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/slide/redo/{slideId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/backgroundconfiguration/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {SlideBackgroundConfigurationDownloadDto[]}
    ******************************************************************************************************/
    SlideshowController.GetBackgroundConfigurations = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/backgroundconfiguration/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/slideshow/template/{templateId?}" and http method "GET" to call the back-end.
    Gets all available slide templates
    
        * @param {string} templateId
        * @returns {SlideTemplateDownloadDto[]}
    ******************************************************************************************************/
    SlideshowController.GetTemplates = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/template/{templateId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/access/{slideShowId}" and http method "POST" to call the back-end.
    
        * @param {string} slideShowId
        * @param {AccessTokenUploadDto} accessToken
        * @returns {SlideShowDownloadDto}
    ******************************************************************************************************/
    SlideshowController.CreateAccessToken = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/access/{slideShowId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.accessToken
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/access/{slideShowId}/{accessTokenId}" and http method "PATCH" to call the back-end.
    
        * @param {string} slideShowId
        * @param {string} accessTokenId
        * @param {AccessTokenUploadDto} accessToken
        * @returns {SlideShowDownloadDto}
    ******************************************************************************************************/
    SlideshowController.ChangeAccessToken = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/access/{slideShowId}/{accessTokenId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.accessToken
        });
    };
    /*****************************************************************************************************
        * Is using route "api/slideshow/access/{slideShowId}/{accessTokenId}" and http method "DELETE" to call the back-end.
    
        * @param {string} slideShowId
        * @param {string} accessTokenId
        * @returns {SlideShowDownloadDto}
    ******************************************************************************************************/
    SlideshowController.RemoveAccessToken = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/access/{slideShowId}/{accessTokenId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/slideshow/{slideShowId}/{accessTokenId}/public" and http method "GET" to call the back-end.
    
        * @param {string} slideShowId
        * @param {string} accessTokenId
        * @returns {SlideShowDownloadDto}
    ******************************************************************************************************/
    SlideshowController.GetSlideShowForPublic = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/slideshow/{slideShowId}/{accessTokenId}/public", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return SlideshowController;
}());
export { SlideshowController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=SlideshowController.js.map